import React, { useEffect } from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateDrawingFolder } from "../services/drawingFoldersAPI";
import { useAuth } from "../hooks/useAuth";

const UpdateDrawingFolderModal = ({ visible, onClose, folder }) => {
  const { selectedProject } = useAuth();
  const projectId = selectedProject?.project_id;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  useEffect(() => {
    if (folder) {
      form.setFieldsValue({
        name: folder.name,
        description: folder.description,
      });
    }
  }, [folder, form]);

  const mutation = useMutation({
    mutationFn: (data) => updateDrawingFolder(projectId, folder._id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(["drawingFolders", projectId]);
      onClose();
      notification.success({ message: "Folder updated successfully" });
    },
    onError: (error) => {
      notification.error({
        message: "Failed to update folder",
        description: error.message,
      });
    },
  });

  const handleUpdateFolder = (values) => {
    mutation.mutate(values);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      title="Update Drawing Folder"
      open={visible}
      onCancel={handleClose}
      footer={null}
    >
      <Form form={form} onFinish={handleUpdateFolder} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the folder name!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={mutation.isPending}
            style={{ width: "100%" }}
          >
            Update Folder
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateDrawingFolderModal;
